import { useLayoutEffect } from 'react';

import type { AddOnsSubscriptionManager } from '@ctct/application-layer';
import type { BillingStrategyQuery } from '@ctct/domain-layer';
import { useCancelAddOnSubscriptionMutation, useEntitlement } from '@ctct/state-server-layer';

import { useIsSingleBillChildAccount } from '../helpers/useIsSingleBillChildAccount';

export interface Props {
  initializer: Pick<AddOnsSubscriptionManager, 'addOnsSubscriptionInit'>;
  billingStrategy: BillingStrategyQuery;
}

export const useAddOnsSubscriptionWidget = ({ initializer, billingStrategy }: Props) => {
  const cancelAddOnSubscription = useCancelAddOnSubscriptionMutation();
  const SMSEntitlement = useEntitlement('SMS', 'SEND');
  const isSingleBillChildAccount = useIsSingleBillChildAccount({ billingStrategy });

  useLayoutEffect(() => {
    initializer.addOnsSubscriptionInit({
      queries: [SMSEntitlement],
      mutations: [cancelAddOnSubscription],
      isSingleBillChildAccount: Boolean(isSingleBillChildAccount),
    });
  }, [SMSEntitlement, cancelAddOnSubscription, initializer, isSingleBillChildAccount]);
};
